import axios from 'axios';

export class MaintenanceAccountsService {
    /**
     * Función que hace una petición al back y obtiene las cuentas con las que
     * se llenará la vista.
     * @returns {Promise<any>}
     */
    getAccounts() {
        return axios.get('/appapv/getAccounts.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload);
    }

    /**
     * Función que hace una petición al back y obtiene el detalle
     * de la cuenta que se indica con el número.
     * @returns {Promise<any>}
     */
    getInfoAccount(account) {
        return axios.get('/appapv/getInfoAccount.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                cuenta: account,
            }
        }).then(res => res.data.payload[0]);
    }

    /**
     * Función que hace una petición al back y borra la cuenta seleccionada.
     * @param account Cuenta que se va a borrar.
     * @returns {Promise<any>}
     */
    deleteAccount(account) {
        return axios.delete('/appapv/deleteAccount.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                cuenta: account,
            }
        }).then(res => {
            this.getAccounts();
            return res.data;
        });
    }

    /**
     * Función que hace una petición al back para insertar un nuevo elemento.
     * @param objectAccount Elemento a insertar
     * @returns {Promise<any>}
     */
    insertAccount(objectAccount) {
        return axios.post('/appapv/insertAccount.action', {}, {
            params: {
                cuenta: objectAccount.cuenta,
                descrCuenta: objectAccount.descrCuenta,
                idInst: objectAccount.idInst,
                folioInst: objectAccount.folioInst,
                boveda: objectAccount.boveda,
                nombreCorto: objectAccount.nombreCorto,
                cuentaEfectivo: objectAccount.cuentaEfectivo,
                banderaCuentaEfvo: objectAccount.banderaCuentaEfvo,
                cuentaValorGSS: objectAccount.cuentaValorGSS ? objectAccount.cuentaValorGSS.cuentaValorGSS : '',
                cuentaEfectivoGSS: objectAccount.cuentaValorGSS ? objectAccount.cuentaValorGSS.cuentaEfectivoGSS : '',
            }
        }).then(res => {
            this.getAccounts();
            return res.data;
        });
    }

    /**
     * Función que realiza una llamada al back,
     * para actualizar los valores de un objeto existente
     * @param objectAccount Objeto modificado.
     * @returns {Promise<any>}
     */
    updateAccount(objectAccount, cuentaValorGSS) {
        return axios.put('/appapv/updateAccount.action', {}, {
            params: {
                cuenta: objectAccount.cuenta,
                descrCuenta: encodeURIComponent((objectAccount.descrCuenta)),
                idInst: objectAccount.idInst,
                folioInst: objectAccount.folioInst,
                boveda: objectAccount.boveda,
                nombreCorto: encodeURIComponent((objectAccount.nombreCorto)),
                cuentaEfectivo: objectAccount.cuentaEfectivo,
                banderaCuentaEfvo: objectAccount.banderaCuentaEfvo,
                cuentaValorGSS: objectAccount.cuentaValorGSS,
                cuentaEfectivoGSS: objectAccount.cuentaEfectivoGSS,
            }
        }).then(res => res.data);
    }

    getInfoNewAccount() {
        return axios.get('/appapv/getInfoNewAccount.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload[0]);
    }
}